import {
  Modal,
  Stack,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  Grid,
  TextField
} from "@mui/material";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
const ShareResumeBuilder = (props) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const drawerWidth = 240;

  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.ResumeBuilder || {};
  const {
    TEXT_ENTER_THE_TITLE = English.ResumeBuilder.TEXT_ENTER_THE_TITLE,
    TEXT_TITLE = English.ResumeBuilder.TEXT_TITLE,
    TEXT_RECIPIENTS = English.ResumeBuilder.TEXT_RECIPIENTS,
    TEXT_ADD_CONTACT_OR = English.ResumeBuilder.TEXT_ADD_CONTACT_OR
  } = LanguageData || {};

  return (
    <Modal open={props?.tutorialIndex === 0 ? false : true}>
      <Box sx={{ backgroundColor: "rgba(0, 0, 0, 0.7)", height: "100%" }} onClick={props.onPress}>
        <Box
          className="user-modal-responsive2"
          sx={{
            top: "30% !important",
            boxShadow: "none",
            backgroundColor: "transparent !important"
          }}>
          <Grid
            sx={{
              maxHeight: isSmallScreen ? "500px" : isMediumScreen ? "600px" : "100%",
              overflowY: "auto",
              scrollbarWidth: "none",
              backgroundColor: "transparent !important"
            }}
            container
            spacing={{ xs: 1, md: 3 }}>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                md: 6.5,
                lg: 6.5,
                xl: 6.5
              }}></Grid>
            <Grid
              sx={{
                p: 2,
                height: "100%",
                overflowY: "auto",
                scrollbarWidth: "none",
                backgroundColor: "white"
              }}
              size={{ xs: 12, sm: 12, md: 5.5, lg: 5.5, xl: 5.5 }}>
              <Stack spacing={2}>
                <Stack spacing={1}>
                  <Typography variant="body1" fontWeight={"bold"}>
                    {TEXT_ENTER_THE_TITLE}
                  </Typography>
                  <TextField placeholder={TEXT_TITLE} size="small"></TextField>
                </Stack>
                <Stack spacing={1}>
                  <Typography variant="body1" fontWeight={"bold"}>
                    {TEXT_RECIPIENTS}
                  </Typography>
                  <TextField placeholder={TEXT_ADD_CONTACT_OR} size="small"></TextField>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};

export default ShareResumeBuilder;
